import { Card } from '@/components/ui/card';
import { formatCryptoPrice, formatTimeAgo, formatValueWithCompactNumber } from '@/lib/format';
import { cn } from '@/lib/utils';
import TokenAvatar from '@/widget/TokenAvatar';
import { useTranslation } from 'react-i18next';
import { Link } from '@/widget/Icon';
import { useTheme } from '@/components/ThemeProvider';
import BigNumber from 'bignumber.js';
import { IAddressHistory } from '@/request/smartMoney/smartMoney.response.interface';
import { useTradeStore } from '@/page/trade/store';
import { useAppStore } from '@/store';

interface IProps {
  order: IAddressHistory;
}
export default (props: IProps) => {
  const { order } = props;
  const { tokenInfo } = useTradeStore();
  const { lang, chainInfo } = useAppStore();
  const { t } = useTranslation();
  const { theme } = useTheme();
  const TradeTypeTag = (type: 'buy' | 'sell') => {
    const colorClass = type == 'buy' ? 'text-buyColor bg-[#1FB9831F]' : 'text-sellColor bg-[#FF5F5F1A]';
    const label = type == 'buy' ? 'Buy' : 'Sell';
    return <div className={cn('px-[6px] py-0 rounded-[4px] flex-shrink-0 flex items-center', colorClass)}>{label}</div>;
  };

  const onViewHx = (signature: string) => {
    if (chainInfo.chain == 'bsc') {
      window.open('https://bscscan.com/tx/' + signature);
    } else {
      window.open('https://solscan.io/tx/' + signature);
    }
  };

  const totalUsd = BigNumber(order.price).times(order.amount).toString();

  return (
    <Card className="p-[12px] rounded-[8px] text-[12px] shadow-none">
      <div className="py-[6px] flex justify-between">
        <div className="flex items-center gap-x-[4px]">
          {TradeTypeTag(order.type)}
          <TokenAvatar logo={tokenInfo?.logo || ''} address={tokenInfo?.address || ''} />
          <span className="text-[14px] flex-shrink-0">{tokenInfo?.symbol}</span>
        </div>
        <div className="flex justify-between">
          <div className="text-secondaryTextColor flex items-center gap-x-[4px]">
            <span>{formatTimeAgo(order.activeTime, { style: 'long', lang })}</span>
            <Link customColor={theme == 'dark' ? '#A1A1AA' : '#09090B80'} className="w-[16px] h-[16px]" onClick={() => onViewHx(order.signature)} />
          </div>
        </div>
      </div>
      <div className="py-[6px] flex justify-between">
        <span className="text-secondaryTextColor">{t('Trade.price')}</span>
        <span>${formatCryptoPrice(order.price)}</span>
      </div>
      <div className="py-[6px] flex justify-between">
        <span className="text-secondaryTextColor">{t('Trade.total')} USD</span>
        <span>${formatValueWithCompactNumber(totalUsd)}</span>
      </div>
      <div className="py-[6px] flex justify-between">
        <span className="text-secondaryTextColor">{t('Trade.amount')}</span>
        <span>{formatValueWithCompactNumber(order.amount)}</span>
      </div>
    </Card>
  );
};
